class MoonBoxConfigurator extends HTMLElement {
  connectedCallback() {
    this.vehicleSelect = this.querySelector('[data-moon-vehicle]');
    this.help = this.querySelector('[data-moon-vehicle-help]');
    this.picker = this.querySelector('variant-picker');
    this.storageKey = `moon-box-vehicle:${this.dataset.productId}`;

    if (!this.vehicleSelect || !this.picker) return;

    this.vehicleSelect.addEventListener('change', () => this.vehicleChanged());
    this.pickerObserver = new MutationObserver(() => {
      this.refreshPicker();
    });
    this.pickerObserver.observe(this.picker, { childList: true, subtree: true });

    const savedVehicle = sessionStorage.getItem(this.storageKey);
    if (savedVehicle && this.vehicleSelect.querySelector(`option[value="${CSS.escape(savedVehicle)}"]`)) {
      this.vehicleSelect.value = savedVehicle;
    }

    this.refreshPicker();
  }

  disconnectedCallback() {
    this.pickerObserver?.disconnect();
  }

  refreshPicker() {
    this.widthFieldset = this.querySelector('[data-moon-width-fieldset]');
    if (!this.widthFieldset) return;
    this.applyVehicle(false);
  }

  vehicleChanged() {
    if (!this.vehicleSelect) return;

    if (this.vehicleSelect.value) {
      sessionStorage.setItem(this.storageKey, this.vehicleSelect.value);
    } else {
      sessionStorage.removeItem(this.storageKey);
    }

    this.applyVehicle(true);
  }

  applyVehicle(changeVariant) {
    const selectedVehicle = this.vehicleSelect?.selectedOptions[0];
    const angle = selectedVehicle?.dataset.angle;
    const fitLabels = Array.from(this.querySelectorAll('[data-moon-fit-label]'));

    if (!angle) {
      delete this.dataset.moonAngle;
      this.widthFieldset.hidden = true;
      fitLabels.forEach((label) => {
        label.hidden = true;
      });
      if (this.help) this.help.textContent = 'Select your vehicle to show the compatible cabinet widths.';
      return;
    }

    this.dataset.moonAngle = angle;
    this.widthFieldset.hidden = false;
    fitLabels.forEach((label) => {
      label.hidden = label.dataset.angle !== angle;
    });

    if (this.help) {
      this.help.textContent =
        selectedVehicle?.dataset.confirm === 'true'
          ? 'Van der Moon lists two fits for the ProAce Max H3. Please confirm the angle before ordering.'
          : 'The mounting angle is selected automatically from Van der Moon’s vehicle fitment data.';
    }

    if (!changeVariant) return;

    const current = this.querySelector('[data-moon-fit]:checked');
    if (current?.dataset.angle === angle) return;

    const currentWidth = current?.dataset.width;
    const candidates = Array.from(this.querySelectorAll(`[data-moon-fit][data-angle="${CSS.escape(angle)}"]`));
    const target = candidates.find((input) => input.dataset.width === currentWidth) || candidates[0];

    if (target instanceof HTMLInputElement) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

if (!customElements.get('moon-box-configurator')) {
  customElements.define('moon-box-configurator', MoonBoxConfigurator);
}
